<template>
  <div class="content mine" >
    <div class="wraper_bg">
      <div class="info">
        <div class="info_photo">
          <img :src="[userinfo.img_url?userinfo.img_url:'/static/images/photo.png']" alt="">
        </div>
        <div class="info_name">
          <p class="info_name_call">
            {{userinfo.wx_name?userinfo.wx_name:"游客"}}
          </p>
          <p class="info_name_uid" v-if="userinfo.id">uid:{{userinfo.id}}</p>
          <!-- <p class="info_name_grade"><span>i</span>会员等级：26</p> -->
        </div>
        <div class="info_balance" v-if="userinfo.id">
          <div class="router-link" @click="rechargemoney">
            余额充值
          </div>
        </div>
      </div>
      <div class="info_under">
        <div class="info_under_price divide-line right-border">
          <h3 class="info_id">{{userinfo.count?userinfo.count:0}}</h3>
          <p>余额</p>

        </div>
        <div class="info_under_card divide-line none">
          <h3 class="info_id">6</h3>
          <p>卡券</p>

        </div>
        <div class="info_under_recharge none">
          <h3 class="info_id">186</h3>
          <p>积分</p>
        </div>
      </div>

    </div>
    <!-- 清单列表 -->
    <div class="wraper_list wraper_list_shadow">
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/qianbao.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          <router-link to="/wallet" class="router-link">
            钱包
          </router-link>
        </div>
      </div>
    </div>
    <div class="wraper_list wraper_list_shadow">
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id" @click="editphone()">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/home.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          常用号码
          <font class="margin-r">{{userinfo.Commonnumber}}</font>
        </div>
      </div>
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/liuyan.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          <router-link to="/proposal" class="router-link">
            投诉建议
          </router-link>
        </div>
      </div>
      <div class="weui-cell weui-cell_flex  weui-cell_select-after" v-if="userinfo.id" @click="clearOrder()">
        <div class="weui-cell__hd weui-cell_flex">
          <img src="/static/images/qingchu.png" alt="">
        </div>
        <div class="weui-cell__bd weui-cell_flex icon-select " id="">
          清除充值记录
        </div>
      </div>
    </div>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
      <div>
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
          :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <navBar :idx="3"></navBar>
  </div>
</template>

<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import navBar from '@/components/navBar';
  import vueQr from 'vue-qr'

  export default {
    name: 'mine',
    components: {
      navBar,
      vueQr
    },
    data() {
      return {
        userinfo: {},
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
        },
      }
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (!auth_token) {
        this.$message({
          message: "请先登录！",
          type: "warning",
        })
        setTimeout(() => {
          this.$router.push('/');
        }, 2000);
      } else {
         this.getUserInfo();
      }
    },
    methods: {
      getUserInfo() {
        this.$api
          .request('Member/getInfo', {})
          .then(({ data }) => {
            this.userinfo = data;
          })
          .catch(error => {
            this.$message({
              message: error+"获取用户信息失败！",
              type: "warning"
            })
          });
      },
      clearOrder() {
        this.$confirm('此操作将删除您的全部充值记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api
            .request('Order/del', {})
            .then(({ data }) => {
              this.$message({
                message: data.msg,
                type: "warning"
              })
            })
            .catch(error => {
              this.$message({
                message: "删除失败！",
                type: "warning"
              })
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      editphone() {
        this.$router.push('/phoneset');
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.sign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      rechargemoney() {
        this.$prompt('', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: "请输入充值金额（₱）",
          center: true,
          inputPattern: /^[0-9]*[1-9][0-9]*$/,
          inputErrorMessage: '只能充值整数'
        }).then(({value}) => {
          this.$api
            .request('Order/create', {type:2, client: this.$client, amount: value})
            .then(({ data }) => {
              switch(this.$client) {
               case 'h5':
                  switch (data.type) {
                    case "1":
                      this.downloadData.url = data.result.data.content;
                      break;
                    case "2":
                      this.downloadData.url = data.result.results.qrcode;
                      break;
                    default:
                      this.$message({
                        message: "暂不支持的支付类型！",
                        type: "warning"
                      })
                      break;
                  }
                  this.centerDialogVisible = true;
                  delay(() => {
                    this.checkorder(data.result.results.out_trade_no)
                  }, 3000)
                  break;
               case 'wxh5':
                  switch (data.type) {
                    case "1":
                      let params = JSON.parse(data.result.data.content);
                      this.wxpay(params);
                      break;
                    case "2":
                      window.location.href = data.result.results.api_url;
                      break;
                    default:
                      this.$message({
                        message: "暂不支持的支付类型！",
                        type: "warning"
                      })
                      break;
                  }
                  break;
               case 'magapp':
                  this.magpay(data.result);
                  break;
               default:
                  this.$message({
                    message: "暂不支持的客户端！",
                    type: "warning"
                  })
                  break;
              }
            })
            .catch(error => {
              this.$message({
                message: error+"下单失败,请联系客服！",
                type: "warning"
              })
            });
        }).catch(() => {
        });
        return;
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
    }
  }
</script>

<style scoped lang="less">
  @import url("../../static/less/mine.less");

  .none {
    display: none !important;
  }

  .info_under .divide-line::after {
    border-right: rgba(0, 0, 0, 0) !important;
  }

  .el-input__inner {
    position: relative;
  }

  .margin-r {
    margin-left: 10px;
  }

  .cphone {
    border: 1px solid #cc6810;
    color: #cc6810;
    border-radius: 4px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/page/mine.vue